/**
 * Value helpers shared by the credential detail renderers.
 *
 * Separate from the components so the primitives file exports components only —
 * mixing the two breaks React Fast Refresh for the whole module.
 */

export type Details = Record<string, unknown>;

/** Narrow an unknown `details` blob (or a nested record inside one). */
export const asDetails = (value: unknown): Details =>
  value && typeof value === "object" && !Array.isArray(value)
    ? (value as Details)
    : {};

/** Money stored as a plain number — insurance limits and claim amounts. */
export const money = (value: unknown) =>
  typeof value === "number"
    ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      }).format(value)
    : null;

/** The shared address shape, as a single line. Null when nothing is recorded. */
export function addressLine(address: unknown): string | null {
  const value = asDetails(address);
  const line = [
    value.street1,
    value.street2,
    value.city,
    value.state,
    value.zipCode ?? value.postalCode,
    value.country,
  ]
    .filter(Boolean)
    .join(", ");
  return line || null;
}
